import { render, staticRenderFns } from "./CardPostsFeed.vue?vue&type=template&id=e9ffcc8c&"
import script from "./CardPostsFeed.vue?vue&type=script&lang=js&"
export * from "./CardPostsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports